import React, { useRef } from 'react';
import HomeHero from './HomeHero';
import AppsShowcase from './AppsShowcase';
import HireSection from './HireSection';
import { SANS } from '../../constants/fonts';

function HomeScreen() {
  const appsRef = useRef(null);
  const hireRef = useRef(null);

  return (
    <div style={s.page}>
      <HomeHero />
      <AppsShowcase appsRef={appsRef} />
      <HireSection hireRef={hireRef} />
    </div>
  );
}

const s = {
  page: {
    minHeight: '100vh',
    background: '#f9f9f7',
    color: '#2a2a2a',
    fontFamily: SANS,
  },
};

export default HomeScreen;
